import React from 'react';

import { EdicaoStatus, SecaoAprovacaoStatus } from 'types/Relatorios/Aprovacao';

import './index.scss';

export type StatusDotStatus = SecaoAprovacaoStatus | EdicaoStatus;

export interface StatusDotProps {
  status: StatusDotStatus;
  label?: string;
}

const CLASSE_POR_STATUS: Record<StatusDotStatus, string> = {
  aprovada: 'relatorio-aprovacao-status-dot--aprovada',
  pendente: 'relatorio-aprovacao-status-dot--pendente',
  publicado: 'relatorio-aprovacao-status-dot--aprovada',
  em_revisao: 'relatorio-aprovacao-status-dot--pendente',
  sem_informe: 'relatorio-aprovacao-status-dot--neutro',
};

const LABEL_POR_STATUS: Record<StatusDotStatus, string> = {
  aprovada: 'Aprovada',
  pendente: 'Pendente de aprovação',
  publicado: 'Aprovado e publicado',
  em_revisao: 'Em revisão — acessível só para admin',
  sem_informe: 'Futuro / sem informe',
};

/**
 * Bolinha de 7px usada nas abas de seção, na pill de status e — com os
 * status de dia (`publicado`/`em_revisao`/`sem_informe`) — no calendário do
 * `ControlPanel` (admin).
 */
export default function StatusDot({ status, label }: StatusDotProps) {
  const ariaLabel = label ?? LABEL_POR_STATUS[status];

  return (
    <span
      className={`relatorio-aprovacao-status-dot ${CLASSE_POR_STATUS[status]}`}
      role="img"
      aria-label={ariaLabel}
    />
  );
}
